import { Loader } from "@mantine/core";

function QuicklinkLoader() {
  return <Loader size="xs" type="bars" />;
}
export { QuicklinkLoader };
